/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var R2ROptionsEnum;

(function (R2ROptionsEnum) {
  R2ROptionsEnum["PROPERTY_SOURCING_ONLY"] = "property_sourcing_only";
  R2ROptionsEnum["R2R_AND_PROPERTY_SOURCING"] = "r2r_and_property_sourcing";
  R2ROptionsEnum["R2R_ONLY"] = "r2r_only";
})(R2ROptionsEnum || (R2ROptionsEnum = {}));